@if (errors.currentError) {
  <span class="block pl-0.75 leading-[110%]">
    {{ errors.currentError }}
  </span>
}
